module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/vi/1-6f0dae6356491408cbe0dd22fa410a71.jpg";